import computeLowestPriceBadge from "@/utils/computeLowestPriceBadge";
import logger from "@/utils/logger";
import Cookies from "js-cookie";

export default async function getVendorOptions(
  mpId: number,
  quantity: number,
  zipCode?: string,
  manufacturer?: string,
  isManufacturerSponsor: boolean = false,
): Promise<VendorOptionState[]> {
  try {
    const buyBoxFactorId = Cookies.get("buyBoxFactorIdExperiment");
    const applyAuthorizedBoosting = Cookies.get("applyAuthorizedBoostedExperiment");
    let url = `/rest/neo/pdp/${mpId}/vendor-options?quantity=${quantity}&postalCode=${zipCode}`;

    if (isManufacturerSponsor) {
      url += `&isManufacturerSponsor=true`;
    }

    if (buyBoxFactorId) {
      url += `&buyBoxFactorId=${buyBoxFactorId}`;
    }
    if (applyAuthorizedBoosting ?? false) {
      url += `&applyAuthorizedBoosting=${applyAuthorizedBoosting}`;
    }
    url = url.concat(`&multiVendorBuyBoxEnabled=true`);
    const response = await fetch(url, {
      credentials: "include",
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    if (response.ok) {
      const data = await response.json();
      const vendorOptionStateList = computeLowestPriceBadge(mpId, quantity, data, manufacturer);
      return vendorOptionStateList?.filter((vendor) => vendor?.inStock);
    } else {
      logger.error(`Error: ${response.status} - ${response.statusText}`);
      return [];
    }
  } catch (error) {
    logger.error(error);
    return [];
  }
}
